<template>
  <div class="tab-bar">
    <div class="tab-bar__items">
      <tab-bar-item
        v-for="tabBarItem in tabBarItems"
        :key="tabBarItem.tab"
        :is-active="isActiveTabBarItem(tabBarItem)"
        :tab-bar-item="tabBarItem"
        @click="onTabBarItemClick"
      />
    </div>
  </div>
</template>

<script>
// @flow

import TabBarItem from './TabBarItem.vue'

export default {
  components: {
    TabBarItem
  },
  props: {
    currentTab: {
      type: String, // WidgetTab
      default: 'chat'
    }
  },
  computed: {
    tabBarItems (): Array<Object> {
      return [
        { tab: 'chat', label: this.$t('tabBar.chat'), icon: 'chat' },
        { tab: 'wizard', label: this.$t('tabBar.productAdvisor'), icon: 'wizard' }
      ]
    }
  },
  methods: {
    isActiveTabBarItem (tabBarItem: Object): boolean {
      return this.currentTab === tabBarItem.tab
    },
    onTabBarItemClick (tabBarItem: Object): void {
      this.$emit('tab-change', tabBarItem.tab)
    }
  }
}
</script>

<style src="./tab-bar.scss" />
